// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__THlSD","subheader":"ReorderModal_subheader__2LPwb","listWrap":"ReorderModal_listWrap__M6dNg"};